import _reactSplitTextCjsProductionMin from "./react-split-text.cjs.production.min.js";
export { _reactSplitTextCjsProductionMin as default };
export const __esModule = _reactSplitTextCjsProductionMin.__esModule,
      LetterWrapper = _reactSplitTextCjsProductionMin.LetterWrapper,
      LineWrapper = _reactSplitTextCjsProductionMin.LineWrapper,
      SplitText = _reactSplitTextCjsProductionMin.SplitText,
      WordWrapper = _reactSplitTextCjsProductionMin.WordWrapper;